import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './pages/home';
import Education from './pages/education';
import ErrorPage from './reusable-components/error-page';
import { get, ref } from 'firebase/database';
import { database, remoteConfig } from './utils/firebase';
import RootLayout from './pages/RootLayout';
import { ThemeProviderWrapper } from './utils/ThemeContext';
import Work from './pages/work';
import Projects from './pages/projects';
import { fetchAndActivate } from 'firebase/remote-config';

remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

await fetchAndActivate(remoteConfig);

const loadReCaptchaScript = () => {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=6LdlhuAqAAAAAKu2OwDigCPRNScdFQQpA6UtXXOS`;
  script.defer = true;
  document.body.appendChild(script);
};

loadReCaptchaScript();

async function loader() {
  const educationDataRef = ref(database);
      const snapshot = await get(educationDataRef); 
      return snapshot.val();
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    loader: loader,
    children: [
      {
        path: "/",
        element: <Home />, 
        loader: loader,
      },
      {
        path: "/home",
        element: <Home />, 
        loader: loader,
      },
      {
        path: "/work",
        element: <Work />,
        loader: loader, 
      },
      {
        path: "/education",
        element: <Education />,
        loader: loader, 
      },
      {
        path: "/projects",
        element: <Projects />,
        loader: loader, 
      },
    ]
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProviderWrapper>
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </ThemeProviderWrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
